module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/index.html
// module id = 248
// module chunks = 0